/**
 * Transaction type values
 */
export enum TransactionTypeEnum {
	/**
	 * Purchase invoices are used when recording purchases from suppliers such as distributors, maintenance providers, and other vendors.
	 */
	PURCHASE_INVOICE = 'purchase_invoice',

	/**
	 * Purchase credits are used when recording returns or refunds from suppliers.
	 */
	PURCHASE_CREDIT = 'purchase_credit',

	/**
	 * Sales invoices are used when recording sales made to customers.
	 */
	SALES_INVOICE = 'sales_invoice',

	/**
	 * Sales credits are used when recording reductions or discounts issued to customers.
	 */
	SALES_CREDIT = 'sales_credit',

	/**
	 * Receipts are used when recording amounts received from customers.
	 */
	RECEIPT = 'receipt',

	/**
	 * Payments are used when recording amounts paid to suppliers.
	 */
	PAYMENT = 'payment',

	/**
	 * Deposits are used when recording advance payments made by customers.
	 */
	DEPOSIT = 'deposit',

	/**
	 * Refunds are used when recording amounts returned to customers.
	 */
	REFUND = 'refund',
}
